module.exports = __webpack_public_path__ + "img/kitchen-supplies.900ce0d4.png";